module.exports = "/_next/static/images/monacoin-d8aef2cd51637fe9d7bd0f0f453c8c19.png";